if (!window.Eurus.loadedScript.has('recently-viewed.js')) {
  window.Eurus.loadedScript.add('recently-viewed.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xProductRecently', {
        show: false,
        productsToShow: 0,
        productsToShowMax: 10,
        loading: false,
        loaded: false,
        init() {
          if (document.getElementById('shopify-section-recently-viewed')) {
            this.productsToShow = document.getElementById('shopify-section-recently-viewed').getAttribute("x-products-to-show");
          }
        },
        showProductRecently() {
          if (localStorage.getItem("recently-viewed")?.length) {
            this.show = true;
          } else {
            this.show = false;
          }
        },
        setProduct(productViewed) {
          let productList = [];
          if (localStorage.getItem("recently-viewed")?.length) {
            productList = JSON.parse(localStorage.getItem("recently-viewed")); 
            productList = [...productList.filter(p => p !== productViewed)].filter((p, i) => i<this.productsToShowMax);
            this.show = true;
            let newData = [productViewed, ...productList];
            localStorage.setItem('recently-viewed', JSON.stringify(newData))
          } else {
            this.show = false;
            localStorage.setItem('recently-viewed', JSON.stringify([productViewed]));
          }
        },
        async getProductRecently(sectionId, productId) {
          if (this.loading || this.loaded) return;

          let products = [];
          if (localStorage.getItem("recently-viewed")?.length) {
            products = JSON.parse(localStorage.getItem("recently-viewed"));
            products = productId ? [...products.filter(p => p !== productId)] : products;
            products = products.slice(0,this.productsToShow);
          } else {
            return;
          }

          const el = document.getElementById("shopify-section-recently-viewed");
          if (!el || products.length === 0) {
            this.show = false;
            return;
          }

          const query = products.map(value => "id:" + value).join(' OR ');
          const searchUrl = `${Shopify.routes.root}search?section_id=${sectionId}&type=product&q=${encodeURIComponent(query)}`;
          this.loading = true;

          try {
            const response = await fetch(searchUrl);
            if (!response.ok) {
              throw new Error(`Recently viewed request failed: ${response.status}`);
            }

            const text = await response.text();
            await new Promise((resolve) => {
              if ('requestIdleCallback' in window) {
                window.requestIdleCallback(resolve, { timeout: 2000 });
              } else {
                setTimeout(resolve, 0);
              }
            });

            const parsedSection = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('#shopify-section-recently-viewed');

            if (!parsedSection || !el.isConnected) return;

            const resultsMarkup = parsedSection.innerHTML;
            el.innerHTML = resultsMarkup;
            this.loaded = true;
          } catch (error) {
            console.error(error);
          } finally {
            this.loading = false;
          }
        },
        clearStory() {
          var result = confirm('Are you sure you want to clear your recently viewed products?');
          if (result === true) {
            localStorage.removeItem("recently-viewed");
            this.show = false;
            this.loaded = false;
          }
        }
      })
    })
  });
}
